/* eslint-disable react-hooks/exhaustive-deps */
import { ToastContainer } from 'react-toastify';
import PlanOption from '../../components/PlanOption/PlanOption';
import './styles.css';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import LanguageBox from '../../components/LanguageBox/LanguageBox';
import useSelectPlan from '../../hooks/useSelectPlan';
import PaymentController from '../../controllers/PaymentController.js/PaymentController';
import LogoutButton from '../../components/LogoutButton/LogoutButton';
import useCommonFunctions from '../../hooks/useCommonFunctions';

const logo = require('../../assets/images/fably-logo.png');

function PlansPage() {
  const { t } = useTranslation();
  const { selectedPlan, handleSelectPlan } = useSelectPlan();
  const { handlePayment, loading } = PaymentController(selectedPlan);
  const { goTo } = useCommonFunctions();

  useEffect(() => {
    document.title = t('plans');
  }, [t]);

  useEffect(() => {
    const haveSubscription = localStorage.getItem('haveSubscription');

    if (haveSubscription) {
      goTo('/AlreadyHaveAccount');
    }
  }, [goTo]);

  return (
    <div className="general-container">
      <div className="fade-screen" />
      <LanguageBox />
      <LogoutButton />
      <ToastContainer
        hideProgressBar={true}
        className="toast"
        autoClose={3000}
        pauseOnFocusLoss={false}
      />
      <div className="container-l">
        <img src={logo} alt={t('fablyLogo')} className="fablyLogo mt-100" />
        <h4>{`${t('step')} 2: ${t('chooseYourPlan')}`}</h4>
        <div className="spacer" />
        <div className="plans-cards">
          <PlanOption
            type="monthly"
            price={6.5}
            secondaryPrice={78}
            selected={selectedPlan?.type === 'monthly'}
            onSelect={() =>
              handleSelectPlan({
                type: 'monthly',
                price: 6.5,
                currency: 'USD',
                planName: 'monthly',
                planId: 'monthly',
              })
            }
          />
          <PlanOption
            type="annual"
            price={60.0}
            secondaryPrice={5.0}
            discount={23}
            selected={selectedPlan?.type === 'annual'}
            onSelect={() =>
              handleSelectPlan({
                type: 'annual',
                price: 60.0,
                currency: 'USD',
                planName: 'annual',
                planId: 'annual',
              })
            }
          />
        </div>
        <div className="text-section">
          <h3>{t('tryFree')}</h3>
          <p className="sub-title">{t('cancelAnytime')}</p>
          <h2>{t('withYourSubscription')}</h2>
          <ul className="list">
            <li>{t('benefits.benefit1')}</li>
            <li>{t('benefits.benefit2')}</li>
            <li>{t('benefits.benefit3')}</li>
            <li>{t('benefits.benefit4')}</li>
            <li>{t('benefits.benefit5')}</li>
            <li>{t('benefits.benefit6')}</li>
          </ul>
        </div>
        <button
          type="button"
          onClick={handlePayment}
          className="pay-button mb-100"
          disabled={loading || !selectedPlan}
        >
          {t('next')}
        </button>
      </div>
    </div>
  );
}

export default PlansPage;
